import {z} from "zod"
import {ImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"

export const definition = {
    validation: {
        returns: z.any(),
        parameters: z.object({
            key: z.string(),
            value: z.instanceof(ImageOpNode),
        }),
    },
}
